var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-center mx-auto"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [(!_vm.displayCroppa) ? _c('div', [(_vm.user.profilePic) ? _c('b-img', {
    attrs: {
      "src": _vm.user.profilePic,
      "height": "150",
      "width": "150",
      "rounded": ""
    }
  }) : _c('b-avatar', {
    staticClass: "mb-2",
    attrs: {
      "rounded": "",
      "size": "150px"
    }
  })], 1) : _c('croppa', {
    staticClass: "rounded",
    attrs: {
      "initial-image": _vm.user.profilePic,
      "height": 150,
      "width": 150
    },
    on: {
      "new-image-drawn": _vm.changedAvatar,
      "draw": _vm.changedAvatar
    },
    model: {
      value: (_vm.avatar),
      callback: function($$v) {
        _vm.avatar = $$v
      },
      expression: "avatar"
    }
  }), _vm._v(" "), (_vm.displayCroppa) ? _c('div', [_c('button', {
    staticClass: "btn spnod-admin__form--button btn-secondary btn-sm spnod-button--center",
    on: {
      "click": function($event) {
        return _vm.avatar.rotate()
      }
    }
  }, [_vm._v("\n          Rotate\n      ")])]) : _vm._e()], 1), _vm._v(" "), _c('h4', {
    staticClass: "h4 mb-2"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-center",
    attrs: {
      "id": "links"
    }
  }, [(!_vm.myAccount && _vm.isAdmin) ? _c('div', {
    staticClass: "mb-1",
    attrs: {
      "id": "messaging"
    }
  }, [(!_vm.user.message) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Messages")]), _vm._v(" "), (_vm.loadingMessages) ? _c('span', {
    staticClass: "spinner-border spinner-border-sm text-primary pl-1",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'messages',
        query: {
          messageId: _vm.user.message.messageId,
          threadId: _vm.user.message.threadId
        }
      }
    }
  }, [_vm._v("\n        Messages\n      ")])], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center flex-column"
  }, [_c('a', {
    staticClass: "spnod-admin__form--link mb-1 text-muted",
    attrs: {
      "href": "https://app.termly.io/document/terms-of-use-for-website/6a339b70-c0f6-46e7-ae47-1bb78046b8b9",
      "target": "_blank"
    }
  }, [_vm._v("\n      Terms of Service\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "spnod-admin__form--link text-muted",
    attrs: {
      "href": "mailto:support@spnod.com"
    }
  }, [_vm._v("\n      Contact us\n    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987c5a00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/UserAccount/Profile.vue
// module id = 6/Ij
// module chunks = 2